import React from 'react';
import PropTypes from 'prop-types';
import ChipInput from 'material-ui-chip-input';

class BasicChipInput extends React.Component {
  propTypes = {
    chips: PropTypes.arrayOf(PropTypes.string).required,
    label: PropTypes.string,
    onChange: PropTypes.func.required,
  }

  addChip = (chip) => {
    const { chips } = this.props;
    const next = [...chips, chip];
    this.props.onChange(next);
  }
  removeChip = (chip) => {
    const { chips } = this.props;
    const next = chips.filter((p) => p !== chip);
    this.props.onChange(next);
  }
  render() {
    const {
      chips, label,
    } = this.props;
    return (
      <ChipInput
        value={chips}
        floatingLabelText={label}
        // Some how this component needs all three of the below to work
        onChange={this.props.onChange}
        onRequestAdd={this.addChip}
        onRequestDelete={this.removeChip}
      />
    );
  }
}

BasicChipInput.propTypes = {
  chips: PropTypes.arrayOf(PropTypes.string).isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default BasicChipInput;
